import { createSelector } from 'reselect';
import { get } from 'lodash-es';

import { emptyArray } from 'ui-components/default-props/empty';

const selectSavedFilterViews = (state) => get(state, 'savedFilterViews', emptyArray);
const selectCustomFilterView = (state) => get(state, 'customFilterView');
const selectDefaultFilterView = (state) => get(state, 'defaultFilterView');

export const selectActiveFilterViewId = (state) => get(state, 'activeFilterViewId');

export const selectActiveFilterView = createSelector(
  selectActiveFilterViewId,
  selectDefaultFilterView,
  selectCustomFilterView,
  selectSavedFilterViews,
  (activeFilterViewId, defaultFilterView, customFilterView, savedFilterViews) => {
    const allViews = customFilterView
      ? [...savedFilterViews, defaultFilterView, customFilterView]
      : [...savedFilterViews, defaultFilterView];

    return allViews.find((view) => view.filterViewId === activeFilterViewId);
  },
);
